<div class="mainDevice">
  <div class="flashAndTexts">
    @if (isFlashing) {
      <app-device-flasher
        (newDevice)="addDevice($event)"
        [nbFlashedDevices]="nbFlashedDevices"
      ></app-device-flasher>
    }
    @if (isAssembly() && (isAssembling || waitingWebsocket)) {
      <div
        class="instructionsText"
        >
        @if (isAssembling) {
          <div>
            <p>
              The following devices <img src="assets/assemble_go.png" /> must now be
              assembled to a container as per PSA assembly instructions.
            </p>
            @if (
              isFinishedConfirming &&
              isFinishedWithError &&
              !isConfirming &&
              !connectionError &&
              isAssembly()
              ) {
              <p
                class="instructionsTextError"
                >
                Error : message not received.<br />
              </p>
            }
          </div>
        }
        @if (waitingWebsocket) {
          <div class="loader-holder">
            <div class="LoadingWebsocketNumber">{{ webSocketLoading }} %</div>
            <div class="loaderWebsocket">Loading...</div>
          </div>
        }
      </div>
    }
    @if (
      isFinishedConfirming &&
      !isFinishedWithError &&
      !isConfirming &&
      isAssembly()
      ) {
      <div
        class="instructionsText"
        >
        <p>
          All devices are now registered in PSA T&T Platform.<br /><br />
          Please wait, you will be redirected to device scanning.
        </p>
      </div>
    }

    @if (connectionError) {
      <div>
        <p class="instructionsTextError">
          Unable to reach the server. Please check your internet connection.
        </p>
      </div>
    }
    @if (
      isFinishedConfirming &&
      isFinishedWithError &&
      !isConfirming &&
      !connectionError &&
      isDisassembly()
      ) {
      <div
        >
        <p class="instructionsTextError">
          A device has not been disassembled, please try again.
        </p>
      </div>
    }
    @if (
      (isFinishedConfirming &&
      !isFinishedWithError &&
      !isConfirming &&
      isDisassembly()) ||
      (isDisassembly() && waitingWebsocket)
      ) {
      <div
        class="instructionsText"
        >
        @if (!waitingWebsocket) {
          <p>
            All devices are now dissociated and ready to be assemble again on a new
            Container Type.
          </p>
        }
        @if (waitingWebsocket) {
          <div class="loader-holder">
            <div class="LoadingWebsocketNumber">{{ webSocketLoading }} %</div>
            <div class="loaderWebsocket">Loading...</div>
          </div>
        }
      </div>
    }
  </div>
  @if (!isConfirming || waitingWebsocket) {
    <mat-divider></mat-divider>
  }
  @if (!isConfirming || waitingWebsocket) {
    <div class="deviceList">
      @for (device of waitingWebsocket ? devicesWebsocket : devices; track device) {
        <div>
          <app-device-item
            [device]="device"
            [testEnabled]="testEnabled"
          ></app-device-item>
        </div>
      }
    </div>
  }
  <!-- <div class="divLoader" *ngIf="isConfirming && !waitingWebsocket">
  <div class="loader">Loading...</div>
</div>
</cdk-virtual-scroll-viewport>-->
@if (devices.length > 0) {
  <div class="footerCustom">
    <mat-divider></mat-divider>
    @if (isFlashing && !isConfirming && !alldissociated) {
      <button
        matButton
        class="btnAction"
        (click)="assemble()"
        [disabled]="!actionsEnabled"
        >
        PROCEED TO {{ isDisassembly() ? "DISASSEMBLY" : "ASSEMBLY" }}
      </button>
    }
    @if (
      (isAssembling || (isFinishedConfirming && isFinishedWithError)) &&
      !isConfirming
      ) {
      <button
        matButton
        class="btnAction"
        (click)="test()"
        [disabled]="!actionsEnabled"
        >
        CLICK HERE WHEN FINISHED
      </button>
    }
    @if (!isAssembling && isFinishedConfirming && !isFinishedWithError) {
      <button
        matButton
        class="btnAction"
        (click)="reset()"
        >
        PRESS TO CONTINUE
      </button>
    }
    @if (isConfirming) {
      <button matButton class="btnActionWait">
        PLEASE WAIT
      </button>
    }
  </div>
}
</div>
